// Promote every explicit skill field; never infer technologies from prose.
export function collectCvSkills(draft) {
  const values = [];
  const add = items => {
    if (Array.isArray(items)) values.push(...items.filter(item => typeof item === 'string').map(item => item.trim()).filter(Boolean));
  };
  const visit = item => {
    add(item.technical_environment);
    add(item.environment);
    add(item.technologies);
    add(item.functional_environment);
    for (const section of item.sections || []) {
      if (['technical_environment', 'functional_environment'].includes(section.type)) add(section.items);
    }
    for (const child of [...(item.missions || []), ...(item.projects || [])]) visit(child);
  };
  add(draft.skills?.highlighted);
  for (const category of draft.skills?.categories || []) add(category.items);
  for (const exp of [...(draft.experiences || []), ...(draft.projects || [])]) visit(exp);
  const seen = new Set();
  return values.filter(value => {
    const key = value.toLocaleLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
